import { Star } from "lucide-react";

const Phrase = () => (
  <span className="flex items-center shrink-0">
    {["JUSTICE", "INTEGRITY", "ACCOUNTABILITY"].map((word) => (
      <span key={word} className="flex items-center">
        <span className="font-display font-extrabold uppercase tracking-wide text-cream text-xl sm:text-2xl px-6">
          {word}
        </span>
        <Star className="w-4 h-4 text-gold fill-gold shrink-0" />
      </span>
    ))}
  </span>
);

export const SloganMarquee = () => (
  <div
    className="relative overflow-hidden bg-crimson border-y-4 border-navy py-4 select-none"
    data-testid="slogan-marquee"
    aria-label="JUSTICE ★ INTEGRITY ★ ACCOUNTABILITY"
  >
    <div className="flex w-max animate-marquee">
      {Array.from({ length: 6 }).map((_, i) => (
        <Phrase key={i} />
      ))}
    </div>
  </div>
);

export default SloganMarquee;
